import { loadable } from '@shared/core/loadableFromNamedExport';

export const LazyPopupTrigger = loadable(() => import(/* webpackChunkName: "content/registry-popuptrigger" */ './RegistryPopupTrigger'), 'RegistryPopupTrigger');
